import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';
import TokenManager from '@/utils/auth';
import Home from '@/views/Home.vue';
import Chat from '@/views/Chat.vue';
import Login from '@/views/Login.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { requiresAuth: false }
  },
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { requiresAuth: true }
  },
  {
    path: '/chat',
    name: 'Chat',
    component: Chat,
    meta: { requiresAuth: true }
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = TokenManager.getToken();
  const isLoggedIn = !!token;

  // 如果路由需要认证
  if (to.meta.requiresAuth) {
    if (isLoggedIn) {
      next();
    } else {
      // 未登录，跳转到登录页
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      });
    }
  } else {
    // 如果已登录，访问登录页时跳转到首页
    if (to.path === '/login' && isLoggedIn) {
      next('/');
    } else {
      next();
    }
  }
});

export default router;

